import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';

const RedirectWithSearchParams = withRouter(props => {
  const {
    to,
    from,
    exact,
    location: { search }
  } = props;
  const isString = typeof to === 'string';

  return (
    <Redirect
      to={{ ...(isString ? { pathname: to } : { ...to }), search }}
      from={from}
      exact={exact}
    />
  );
});

export default RedirectWithSearchParams;
